import $ from 'jquery';

export default class StaticArticleList {
  constructor(section) {
    this.$el = $(section.el);

    this.setFeaturedImage(true);
    this.artDirection();
    this.wrapAllNodes();

    $(window).resize(() => {
      this.setFeaturedImage();
    });
  }

  wrapAllNodes() {
    const childNodes = $('.rte', this.$el);

    for (let i = 0; i < childNodes.length; i++) {
      const node = childNodes[i];

      if ((node.nodeType === 3) && node.textContent.replace(/^\s+|\s+$/g, '')) {
        $(node).replaceWith(`<p>${node.textContent}</p>`);
      }
    }
  }

  setFeaturedImage(load) {
    const featuredImage = $('.featured-image', this.$el);

    if (featuredImage.length) {
      if (featuredImage.hasClass('full-bleed-featured-image')) {
        const windowWidth = $(window).width();
        const contentWidth = this.$el.outerWidth(true);

        featuredImage.css({
          width: windowWidth,
          marginLeft: (-1 * (windowWidth - contentWidth)) / 2,
        });
      }

      if (load) {
        featuredImage.addClass('processed');
      }
    }
  }

  artDirection() {
    const images = $('.post-content img', this.$el);

    images.one('rimg:load', () => {
      for (let i = 0; i < images.length; i++) {
        const image = $(images[i]);

        if (!image.hasClass('post-image')) {
          if (image.parent().hasClass('post-content')) {
            image.wrap('<div />');
          }

          const imageParent = image.parent();

          if (image.css('float') !== 'none') {
            const direction = image.css('float');
            imageParent.addClass(`highlight highlight-${direction}`);
          }

          const imageWidth = image.width();
          const imageAlt = image.attr('alt');
          if (imageAlt && imageAlt.length && imageParent.not('img')) {
            const marginLeft = image.css('margin-left');
            const marginRight = image.css('margin-right');
            imageParent.append(`
              <div
                style="
                  max-width: ${imageWidth}px;
                  margin-left: ${marginLeft};
                  margin-right: ${marginRight};
                "
                class="photo-caption meta"
              >
                ${imageAlt}
              </div>
            `);
          }
        }
      }
    });
  }

  onSectionUnload() {
    $('.post-content img', this.$el).off('rimg:load');
  }
}
